import { BusquedaDocumentos } from "./BusquedaDocumentos";
import { DocumentosMasClientes } from "./DocumentosMasClientes";


export class SolicitudDescarga {
    documentosSeleccionados: DocumentosMasClientes;
    filtrosDeBusqueda: BusquedaDocumentos;
    cantidadSolicitada: number;
}